/*
  Landing Silhéa (template product.lp-silhea) : taille de chaque body dans les offres.
  L'option « Taille » du produit a une valeur par combinaison (« S/M », « 2 × S/M », « S/M + L/XL »,
  « 3 × S/M + 1 × L/XL »…), chaque variante gardant le prix exact de son offre. Cette option est masquée
  (type « hidden » du sélecteur de variantes) et pilotée par une liste déroulante par body, affichée
  sous la carte d'offre sélectionnée. Référence : docs/lp-mapping-silhea.md, § 10.
*/
(() => {
  const TAILLES = [
    { valeur: 'S/M', libelle: 'S/M · du 34 au 40' },
    { valeur: 'L/XL', libelle: 'L/XL · du 40 au 46' },
  ];
  const BODIES = { '1 body': 1, '1 acheté + 1 offert': 2, '2 achetés + 2 offerts': 4 };
  const OFFERTS = { 2: 1, 4: 2 };
  const controleurs = new WeakMap();

  // « S/M », « L/XL » → valeur de l'option « Taille » correspondante
  const combinaison = (tailles) => {
    const n = tailles.length;
    const sm = tailles.filter((t) => t === 'S/M').length;
    const lxl = n - sm;
    if (n === 1) return tailles[0];
    if (!lxl) return `${n} × S/M`;
    if (!sm) return `${n} × L/XL`;
    if (n === 2) return 'S/M + L/XL';
    return `${sm} × S/M + ${lxl} × L/XL`;
  };

  // Valeur de l'option « Taille » → taille de chaque body
  const decomposer = (valeur) => {
    const tailles = [];
    for (const partie of valeur.split(' + ')) {
      const m = partie.match(/^(\d+) × (.+)$/);
      if (m) for (let k = 0; k < Number(m[1]); k++) tailles.push(m[2]);
      else tailles.push(partie);
    }
    return tailles;
  };

  function initialiser(vs) {
    const blocs = vs.querySelectorAll(':scope > .product-form__input');
    if (blocs.length < 2) return null;
    const blocOffre = blocs[0];
    const blocTaille = blocs[1];
    const grille = blocOffre.querySelector('.quantity-breaks-container');
    if (!grille || !blocTaille.classList.contains('hidden')) return null;

    const uid = vs.dataset.section || Math.random().toString(36).slice(2);
    const radiosTaille = () => Array.from(blocTaille.querySelectorAll('input[type="radio"]'));
    const offre = () => (blocOffre.querySelector('input:checked') || {}).value;
    const tailleCochee = radiosTaille().find((r) => r.checked);
    const choix = tailleCochee ? decomposer(tailleCochee.value) : ['S/M'];

    const panneau = document.createElement('fieldset');
    panneau.className = 'silhea-tailles-body';

    const nombre = () => BODIES[offre()] || 1;
    const taille = (i) => choix[i] || choix[0] || 'S/M';

    function dessiner() {
      const n = nombre();
      const offerts = OFFERTS[n] || 0;
      panneau.replaceChildren();
      const legende = document.createElement('legend');
      legende.textContent = n > 1 ? 'Choisissez la taille de chaque body' : 'Choisissez votre taille';
      panneau.append(legende);
      for (let i = 0; i < n; i++) {
        const id = `SilheaTaille-${uid}-${i}`;
        const ligne = document.createElement('div');
        ligne.className = 'silhea-tailles-body__ligne';
        const label = document.createElement('label');
        label.htmlFor = id;
        label.textContent = n > 1 ? `Body ${i + 1}${i >= n - offerts ? ' (offert)' : ''}` : 'Taille';
        const select = document.createElement('select');
        select.id = id;
        select.className = 'silhea-tailles-body__select';
        for (const t of TAILLES) select.add(new Option(t.libelle, t.valeur));
        select.value = taille(i);
        select.addEventListener('change', () => {
          choix[i] = select.value;
          appliquer();
        });
        ligne.append(label, select);
        panneau.append(ligne);
      }
      const carte = blocOffre.querySelector('input:checked + .quantity-break') || grille.lastElementChild;
      if (carte) carte.after(panneau);
    }

    function appliquer() {
      const n = nombre();
      const cible = combinaison(Array.from({ length: n }, (_, i) => taille(i)));
      const radio = radiosTaille().find((r) => r.value === cible);
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // Filet de sécurité : le formulaire d'achat doit porter la variante (offre, combinaison).
      setTimeout(() => {
        const json = vs.querySelector('script[type="application/json"]');
        if (!json) return;
        const variante = JSON.parse(json.textContent).find((v) => v.option1 === offre() && v.option2 === cible);
        if (!variante) return;
        document.querySelectorAll(`#product-form-${vs.dataset.section} input[name="id"]`).forEach((input) => {
          if (String(input.value) !== String(variante.id)) {
            input.value = variante.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }, 0);
    }

    // Changement d'offre : on redessine les listes et on choisit la combinaison avant le traitement du thème.
    blocOffre.addEventListener('change', (event) => {
      if (!event.target.matches('input[type="radio"]')) return;
      dessiner();
      appliquer();
    });

    dessiner();
    appliquer();
    return { panneau, dessiner };
  }

  function verifier() {
    document.querySelectorAll('variant-selects').forEach((vs) => {
      const c = controleurs.get(vs);
      if (!c) {
        const nouveau = initialiser(vs);
        if (nouveau) controleurs.set(vs, nouveau);
      } else if (!c.panneau.isConnected) {
        c.dessiner();
      }
    });
  }

  let attente = null;
  new MutationObserver(() => {
    clearTimeout(attente);
    attente = setTimeout(verifier, 50);
  }).observe(document.body, { childList: true, subtree: true });

  verifier();
})();
